import classNames from "classnames"
import React from "react"

import { Color } from "../../../../constants/V2/color"
import { getTextColorClass } from "../../../../utils/V2/color"
import ChevronIcon from "../../../elements/V2/Icons/ChevronIcon"

type Props = {
  onClick?: () => void
  direction: "left" | "right"
  id?: string
  className?: string
}

const GalleryNavButton = ({ onClick, direction, id, className }: Props) => {
  return (
    <button
      id={id}
      onClick={onClick}
      className={classNames(
        "rounded-full bg-transparent p-10 transition-opacity duration-300 sm:bg-white",
        className
      )}
    >
      <ChevronIcon
        className={classNames(
          getTextColorClass(Color.Black),
          direction === "right" ? "-rotate-90" : "rotate-90"
        )}
      />
    </button>
  )
}

export default GalleryNavButton
